<template>
    <div class="main">

        <el-row class="rowbutton" :gutter="20">
            <!-- <el-col :span="20">
                <el-button type="text" @click="formshuoming">操作说明（必看）</el-button>
            </el-col> -->
            <el-col :span="4">
                <el-input size='mini'
                @keyup.enter.native="handquny"
                 v-model="query.site_id" placeholder="输入关键字"></el-input>
            </el-col>

            <el-col :span="1.5">
               
                   <el-button type="success" plain icon="el-icon-edit" size="mini"  @click="handquny">查询</el-button>
            </el-col>
            
            <el-col :span="1.5">
                 <el-button type="primary" plain icon="el-icon-plus" size="mini" @click="handleadvertise">新增广告</el-button>
            </el-col>
            <el-col :span="1.5">
                <el-button type="primary" plain icon="el-icon-plus" size="mini" @click="handleAddimg">新增素材</el-button>
            </el-col>
            <el-col :span="1.5">
              
                 <el-button type="primary" plain icon="el-icon-plus" size="mini" @click="handleAdd">新增模板</el-button>
            </el-col>

        </el-row>

        <el-table
            v-loading="loading"
            :data="list"
            style="width: 100%;margin-top:20px">
            <el-table-column
                label="广告ID"
                prop="id"
                 align='center'>
            </el-table-column>
            <!-- <el-table-column
                label="域名"
                prop="domin"
                 align='center'>
            </el-table-column>
            <el-table-column
                label="目录"
                prop="content"
                 align='center'
                >
            </el-table-column> -->
            <el-table-column
                label="广告链接"
             
                 align='center'
                >
                <template slot-scope="scope">
                    {{`https://${scope.row.domin}/${scope.row.content}`}}
                </template>
            </el-table-column>
            
            <el-table-column
                label="分类"
                prop="list"
                 align='center'>
            </el-table-column>
            <el-table-column
                label="模板"
                prop="temple"
                 align='center'>
            </el-table-column>
            <el-table-column
                label="素材"
                prop="material"
                 align='center'>
            </el-table-column>
            <el-table-column
                label="链接"
                prop="link"
                 align='center'>
            </el-table-column>
            
            <el-table-column
                label="操作"
              
                fixed="right">
                <template slot-scope="scope">
                    <el-button type="success" plain size="mini" @click="handleUpdate(scope.row)">修改</el-button>
                    <el-button type="danger"  plain size="mini" style="margin-right:10px" @click="handleDel(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            :page-size="query.limit"
            @current-change="handleCurrentChange"
            layout="prev, pager, next"
            :total="total">
        </el-pagination>
        <!-- 新增素材 -->
        <el-dialog :close-on-click-modal = "false" @close='aaimg' :visible.sync="openpdfimg" width="600px" append-to-body>
            <el-form :model="formimg" :rules="formRulesimg" label-width="80px" ref="dataFormimg">
                <el-row :gutter="20">
                    <el-col :span="20">
                        <el-form-item label="目录" prop="listimg">
                            <el-select v-model="formimg.listimg" placeholder="请选择">
                                <el-option v-for="item in optionslistimg" :key="item" :label="item" :value="item">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                </el-row>

                <el-form-item label="素材" prop="nameimg">
                    <el-input v-model="formimg.nameimg"></el-input>
                </el-form-item>
                <el-form-item label="上传文件">
                    <el-upload ref="uploadimg" class="upload-demo" :limit="1" drag action="https://nodetcp.com/vue-admin-php/public/index.php/admin/check/upload" :on-success="handle_successimg" multiple>
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                        <div class="el-upload__tip" slot="tip">只能上传jpg/png文件</div>
                    </el-upload>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="formSubmitimg">立即创建</el-button>

                </el-form-item>
            </el-form>
        </el-dialog>

        <!-- 新增模板 -->
        <el-dialog :close-on-click-modal = "false" @close='aa' :visible.sync="openpdf" width="600px" append-to-body>
            <el-button type="text" style="position:relative;top:-15px" @click="formshuoming">操作说明（必看）</el-button>
            <el-form :model="form" :rules="formRules" label-width="80px" ref="dataForm">

                <el-row :gutter="20">
                    <el-col :span="20">
                        <el-form-item label="选择目录" prop="list">
                            <el-select v-model="form.list" placeholder="请选择">
                                <el-option v-for="item in optionslist" :key="item" :label="item" :value="item">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :span="1">
                        <el-button type="primary" style="margin-top:5px" plain size="mini" @click="mululeAdd">新增目录</el-button>
                    </el-col>
                </el-row>

                <el-form-item label="模板名称" prop="name">
                    <el-input v-model="form.name"></el-input>
                </el-form-item>
                <el-form-item label="上传文件">
                    <el-upload ref="upload" class="upload-demo" :limit="1" drag action="https://nodetcp.com/vue-admin-php/public/index.php/admin/check/upload" :on-success="handle_success" multiple>
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                        <!-- <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div> -->
                    </el-upload>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="formSubmit">立即创建</el-button>

                </el-form-item>
            </el-form>
        </el-dialog>
        <!-- 新增广告 -->
        <el-dialog :close-on-click-modal = "false"  :visible.sync="openadvertise" width="800px" append-to-body>
            <div class="lpform">
            <el-form :model="lpform" :rules="lpformRules" label-width="80px" ref="lpdataForm">
                <el-form-item label="操作域名" prop="domin">
                    <el-input :disabled="lpform.id!==''" v-model="lpform.domin"></el-input>
                </el-form-item>
                <el-form-item  label="生成目录" prop="content">
                    <el-input :disabled="lpform.id!==''" v-model="lpform.content"></el-input>
                    <!-- <el-button type="success" @click="copySubmitlp" class="copy-code-button dadabutton" plain :data-clipboard-text="copyjs" size="mini">复制链接</el-button> -->

                </el-form-item>

                <el-form-item label="选择目录" prop="list">
                    <el-select @change='changelp' v-model="lpform.list" placeholder="请选择">
                        <el-option v-for="item in lpformlist" :key="item" :label="item" :value="item">
                        </el-option>
                    </el-select>
                    <el-button type="success" class="dabutton" size="mini" plain @click="deletetem2">删除</el-button>
                </el-form-item>

                <el-form-item label="选择模板" prop="temple">
                    <el-select v-model="lpform.temple" placeholder="请选择">
                        <el-option v-for="item in lptemplelist" :key="item" :label="item" :value="item">
                        </el-option>
                    </el-select>
                    <el-button type="success" class="dabutton" size="mini" plain @click="deletetem1">删除</el-button>
                </el-form-item>

                <el-form-item label="填写链接" prop="link">
                    <el-input v-model="lpform.link"></el-input>
                </el-form-item>

                <el-form-item label="选择素材" prop="material">
                    <el-select v-model="lpform.material" placeholder="请选择">
                        <el-option v-for="item in materiallist" :key="item" :label="item" :value="item">
                        </el-option>
                    </el-select>
                    <el-button type="success" class="dabutton" size="mini" plain @click="deletemet">删除</el-button>
                </el-form-item>

                 <el-form-item label="像素ID" prop="pixel">
                    <el-input  type="textarea"
  :rows="4" v-model="lpform.pixel"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="formSubmitlp">立即生成</el-button>
                    <el-button type="primary" @click="copytiao">跳转</el-button>

                </el-form-item>
            </el-form>
        </div>
        </el-dialog>
        <!-- 自切 -->
        

        <!-- 新增目录 -->
        <el-dialog :close-on-click-modal = "false" title="新增目录" :visible.sync="dialogVisible" width="30%">

            <el-input v-model="mulu"></el-input>

            <el-button type="primary" style="margin-top:10px" plain size="mini" @click="addmulu">确 定</el-button>

        </el-dialog>

        <!-- <el-dialog
  title="新增目录"
  :visible.sync="dialogVisibleimg"
  width="30%"
  >
  
  <el-input v-model="muluimg"></el-input>
   
    <el-button type="primary" style="margin-top:10px" plain  size="mini" @click="addmuluimg" >确 定</el-button>
  
</el-dialog> -->
            <el-dialog title="操作说明" :visible.sync="shuominggVisible" class="shuoming" width="50%">
            <p>1. 新增模板：首先选择目录，输入模板名称。然后上传模板的压缩包。压缩内文件有且只能有一个.html文件，其他类型文件或文件夹没有限制。对html文件需要作如下修改。
            将图片的地址修改为REPLACEHTMLIMAGE，例如 img src="fhfj/dshsh.png"/>修改为img src="REPLACEHTMLIMAGE"\n\r
            将需要自定义的关键字修改为REPLACEHTMLKEYWORD；\n\r
            将需要自定义的跳转链接修改为REPLACEHTMLDOMAIN。
            例如 a href="https://www.baidu.com/"/>修改为a href="REPLACEHTMLDOMAIN"/></p>
            <p style="margin-top:20px">2. 操作域名：不包含前缀http://或者https://,例如http://baidu.com。只填写baidu.com；生成子目录：例如你想生成http://baidu.com/test的链接，这里就填test

            </p>
        </el-dialog>
    </div>

</template>

<script>
import Clipboard from 'clipboard'
import { getlist,parse, deletead,fileQual, getlistlp, list, addlist, parseimg, creat4, creatjs, deletetem } from "../../api/ad/adSite";
// this.$store.state.admin.userName,
export default {
    data() {
        return {
            total:0,
            query: {
                site_id: '',
                title: "",
                page: 1,
                limit: 15
            },
            loading:true,
            list:[],
            openadvertise:false,
            shuominggVisible: false,
            site_id:'',
            lpform: {
                id:'',
                domin: '',
                content: '',
                list: '',
                temple: '',
                link: '',
                material: '',
                pixel:''

            },
            materiallist: [],
            dialogVisibleimg: false,
            openpdfimg: false,
            openpdf: false,
            muluimg: '',
            mulu: '',
            form: {
                name: '',
                file: '',
                list: ''
            },
            formimg: {
                listimg: '',
                nameimg: '',
                fileimg: ''
            },
            optionslist: [],
            optionslistimg: [],
            lptemplelist: [],
            lpformlist: [],
            dialogVisible: false,
            formRules: {
                name: [
                    { required: true, message: '请输入素材名称', trigger: 'blur' },
                ],
                listimg: [
                    { required: true, message: '请选择目录', trigger: 'blur' },
                ],
                list: [
                    { required: true, message: '请选择目录', trigger: 'blur' },
                ]
            },
            formRulesimg: {
                nameimg: [
                    { required: true, message: '请输入素材名称', trigger: 'blur' },
                ],
                listimg: [
                    { required: true, message: '请选择目录', trigger: 'blur' },
                ],
            },
            lpformRules: {
                domin: [
                    { required: true, message: '请输入域名', trigger: 'blur' },
                ],
                content: [
                    { required: true, message: '请输入子目录', trigger: 'blur' },
                ],
                list: [
                    { required: true, message: '请选择模板目录', trigger: 'blur' },
                ],
                temple: [
                    { required: true, message: '请选择模板', trigger: 'blur' },
                ],
                link: [
                    { required: true, message: '请输入跳转链接', trigger: 'blur' },
                ],
                material: [
                    { required: true, message: '请输入素材名称', trigger: 'blur' },
                ]
            }
        }
    },
    computed: {
        // 计算属性的 getter
        copyjs: function () {
            // `this` 指向 vm 实例
            return `http://${this.lpform.domin}/${this.lpform.content}`
        }
    },
    created() {
        
        this.getlist()
    },
    methods: {
        handleCurrentChange(val) {
            this.query.page = val
            this.getlist()
        },
        handquny(){
            this.query.page=1
            this.getlist()
        },
        
        handleDel(row){
            this.$confirm("确认删除该记录吗?", "提示", {
                    type: "warning"
                })
                    .then(() => {
                         deletead(row).then(response=>{
                if(response){
                     this.$message({
                        message: "已删除",
                        type: "success"
                    });
                    this.getlist()
                }
            })
            this.deletetem3(row)

                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "取消删除"
                        });
                    });
          
        },
        handleUpdate(row){

             this.da()
            // this.restlp()
              this.lpform=row
              if(!this.lpform.pixel){
this.lpform.pixel=''
              }
            this.getsucai()
            
            this.gettemple()
        
          this.openadvertise=true
        },
        getlist(){
            this.loading=true
        //  let data={
        //      user:this.$store.state.admin.userName,
        //      site_id:this.site_id
        //  }
         this.query.user = this.$store.state.admin.userName
         getlist( this.query).then(response=>{
         this.list=response
         this.loading=false
         this.total = response.total;
         })
        },
        handleadvertise(){
            this.da()
            this.restlp()
           this.openadvertise=true
        },
        formshuoming() {
            this.shuominggVisible = true
        },
        gettemple() {
            let from = {
                name: this.$store.state.admin.userName,
                mulu: 'list',
                value: this.lpform.list
            }
            getlistlp(from).then(response => {
                // response.list.splice(0, 2)
                this.lptemplelist = response.list.filter((value)=>{
return value!=".."&&value!="."
                })

            })
        },
        getsucai() {
            let from1 = {
                name: this.$store.state.admin.userName,
                mulu: 'img',
                value: this.lpform.list
            }
            getlistlp(from1).then(response => {

                this.materiallist = response.list

            })
        },
         deletetem3(row) {
            // if (!this.lpform.list) {
            //     this.$message.error('请先选择目录');
            //     return
            // }
            let a = {
                list1: row.content,
                name: row.temple,
                user: this.$store.state.admin.userName,
                domin:row.domin,
                type: 'advertise'
            }
            deletetem(a).then(response => {
               
            })
        },
        deletetem2() {
            if (!this.lpform.list) {
                this.$message.error('请先选择目录');
                return
            }

            if(this.lptemplelist.length!==0){
                this.$message.error('该目录下存在模板，不可删除');
                return
            }
           
                    
                        let a = {
                list1: this.lpform.list,
                name: this.lpform.temple,
                user: this.$store.state.admin.userName,
                type: 'mulu'
            }
            deletetem(a).then(response => {
                if (response) {
                    this.$message({
                        message: "删除成功",
                        
                        type: "success"
                    });
                    this.da()
                    this.lpform.list=''
                    this.lpform.temple = ''
                    this.lpform.material = ''
                    this.lptemplelist=[]
                    this.materiallist=[]

                }
                else {
                    this.$message.error('删除失败');
                }
            })

                    
                

     
        },
        deletetem1() {
            if (!this.lpform.temple) {
                this.$message.error('请先选择模板');
                return
            }
            this.$confirm("确认删除当前模板?", "提示", {
                    type: "warning"
                })
                    .then(() => {
                        let a = {
                list1: this.lpform.list,
                name: this.lpform.temple,
                user: this.$store.state.admin.userName,
                type: 'temple'
            }
            deletetem(a).then(response => {
                if (response) {
                    this.$message({
                        message: "删除成功",
                        type: "success"
                    });
                    this.lpform.temple = ''
                    this.gettemple()

                }
                else {
                    this.$message.error('删除失败');
                }
            })

                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "取消删除"
                        });
                    });


     
        },
        deletemet() {
            if (!this.lpform.material) {
                this.$message.error('请选择素材');
                return
            }

            this.$confirm("确认删除当前素材?", "提示", {
                    type: "warning"
                })
                    .then(() => {
                        let a = {
                list1: this.lpform.list,
                name: this.lpform.material + '.png',
                user: this.$store.state.admin.userName + 'img',
                type: 'img'
            }
            console.log(a)
            deletetem(a).then(response => {
                if (response) {
                    this.$message({
                        message: "删除成功",
                        type: "success"
                    });
                    this.lpform.material = ''
                    this.getsucai()

                }
                else {
                    this.$message.error('删除失败');
                }
            })

                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "取消删除"
                        });
                    });

           
        },
        copytiao() {
            window.open(this.copyjs);
        },
        copySubmitlp() {


            var clipboard = new Clipboard('.copy-code-button') // 这里可以理解为选择器，选择上面的复制按钮
            clipboard.on('success', e => {

                // 释放内存
                clipboard.destroy()
            })
            clipboard.on('error', e => {
                // 不支持复制

                // 释放内存
                clipboard.destroy()
            })
            this.$message({
                message: "复制成功",
                type: "success"
            });
        },

        restlp() {
            this.lpform = {
                 id:'',
                domin: '',
                content: '',
                list: '',
                temple: '',
                link: '',
                material: '',
                pixel:''

            }
        },
        submitEmptyText() {
            this.lpform.user = this.$store.state.admin.userName
            creat4(this.lpform).then(response => {
                if (response == 7) {
                    this.$message({
                        message: "创建成功",
                        type: "success"
                    });
                    this.openadvertise=false
                    this.restlp()
                     this.getlist()
                }
                else {
                    this.$message.error(response);
                }
            })
        },
        formSubmitlp() {
            this.$refs["lpdataForm"].validate(valid => {
                if (valid) {
                    this.submitEmptyText()  
                    // let a = {
                    //     domin: this.lpform.domin,
                    //     list: this.lpform.content
                    // }
                //     fileQual(a).then(response => {
                //         if (response) {
                //           console.log(3)
                       
                //            this.submitEmptyText()
                //         }
                //         else{
                //            this.$confirm("此链接已存在，确定修改此链接吗?", "提示", {
                //     type: "warning"
                // }).then(() => {
                //   console.log(44)
         
                //    this.submitEmptyText()     

                //     }).catch(() => {
                //         this.$message({
                //             type: "info",
                //             message: "取消修改"
                //         });
                //     });
                //         }
                //     })

                }
            })

        },
        formSubmitimg() {

            if (!this.formimg.fileimg) {
                this.$message.error('请上传文件');
                return
            }
            this.$refs["dataFormimg"].validate(valid => {
                if (valid) {
                    this.formimg.user = this.$store.state.admin.userName
                    parseimg(this.formimg).then(response => {
                        this.$message({
                            message: "添加成功",
                            type: "success"
                        });
                        if (!this.lpform.list) {
                            this.getsucai()
                        }

                        this.openpdfimg = false
                    })
                }
            })

        },
        addmuluimg() {
            let from = {
                name: this.$store.state.admin.userName,
                mulu: this.muluimg,
                list: 'img'
            }
            addlist(from).then(response => {
                if (response == 'success') {

                    this.$message({
                        message: "创建成功",
                        type: "success"
                    });
                }
                else {
                    this.$message.error(response);
                }
            })

        },
        handle_successimg(response) {

            console.log(response)
            if (response) {
                this.formimg.fileimg = response
            }

            else {
                this.$message.error('上传出错');

            }
            console.log(this.form.file)
        },
        aaimg() {
            this.$refs.uploadimg.uploadFiles = []
        },
        handleAddimg() {
            this.restimg()


            this.openpdfimg = true
            let from = {
                name: this.$store.state.admin.userName,
                mulu: 'img'
            }
            list(from).then(response => {
                // response.list.splice(0, 2)
                this.optionslistimg = response.list.filter((value)=>{
return value!=".."&&value!="."
                })
            })
        },
        addmulu() {
            if (!this.mulu) {
                this.$message.error('请输入目录名称');
                return
            }
            let from = {
                name: this.$store.state.admin.userName,
                mulu: this.mulu,
                list: 'list'
            }
            addlist(from).then(response => {
                if (response == 'success') {
                    this.dialogVisible = false
                    this.$message({
                        message: "创建成功",
                        type: "success"
                    });
                    this.da()
                }
                else {
                    this.$message.error(response);
                }
            })
        },
        mululeAdd() {
            this.dialogVisible = true
            this.mulu = ''
            this.da()
        },
        mululeAddimg() {
            this.dialogVisibleimg = true
            this.mulu = ''
        },

        da() {
            let from = {
                name: this.$store.state.admin.userName,
                mulu: 'list'
            }
            list(from).then(response => {
                // response.list.splice(0, 2)
                this.optionslist = response.list.filter((value)=>{
return value!=".."&&value!="."
                })
                this.lpformlist = response.list.filter((value)=>{
return value!=".."&&value!="."
                })
            })
        },
        changelp(value) {
            let from = {
                name: this.$store.state.admin.userName,
                mulu: 'list',
                value: value
            }
            getlistlp(from).then(response => {
                // response.list.splice(0, 2)
                this.lptemplelist = response.list.filter((value)=>{
return value!=".."&&value!="."
                })

            })
            let from1 = {
                name: this.$store.state.admin.userName,
                mulu: 'img',
                value: value
            }
            getlistlp(from1).then(response => {

                this.materiallist = response.list

            })

        },
        aa() {
            this.$refs.upload.uploadFiles = []
        },
        handleAdd() {
            this.rest()
            this.openpdf = true
            this.da()
        },
        rest() {
            this.form = {
                name: '',
                file: '',
                list: ''
            }
        },
        restimg() {
            this.formimg = {
                listimg: '',
                nameimg: '',
            }
        },
        formSubmit() {
            if (!this.form.file) {
                this.$message.error('请上传文件');
                return
            }

            this.$refs["dataForm"].validate(valid => {
                if (valid) {
                    console.log(this.form.file)
                    this.form.user = this.$store.state.admin.userName
                    parse(this.form).then(response => {
                        if (response == '大头娃') {
                            this.openpdf = false
                            this.$message({
                                message: "解析成功",
                                type: "success"
                            });
                            if (!this.lpform.list) {
                                this.gettemple()
                            }


                        }
                        else {
                            this.openpdf = false
                            this.$message.error(response);
                        }
                    })
                }

            })
        },
        handle_success(response) {

            console.log(response)
            if (response) {
                this.form.file = response
            }

            else {
                this.$message.error('上传出错');
            }
            console.log(this.form.file)
        }
    },
    mounted() {
        this.restlp()
    }
}
</script>
<style>
.lpform .el-select,
.lpform .el-input {
    width: 100% !important;
}
.el-input__inner {
    width: 100% !important;
}
.lpform .el-form-item__content .el-form-item__content {
    align-items: center;
}
.lpform .dabutton {
    position: absolute;
    right: -74px;
}
.lpform .dadabutton {
    position: absolute;
    right: -94px;
}
</style>
<style scoped>
.shuoming {
    line-height: 25px;
}
.lpform {
    width: calc(100% - 90px);
  
}

.rowbutton {
    /* display: flex;
    flex-direction: row-reverse; */
    margin-top: 10px;
}
</style>>

